import { render, staticRenderFns } from "./Inventories.vue?vue&type=template&id=2303f214&scoped=true"
import script from "./Inventories.vue?vue&type=script&lang=js"
export * from "./Inventories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2303f214",
  null
  
)

export default component.exports